import { isPlatformBrowser, Location } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild, ViewContainerRef} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription} from 'rxjs';
import { debounceTime, finalize, first, takeWhile } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import {modalSubscriptionOutOfStockBraze, removeSubscriptionOutOfStock, saveSubscriptionOutOfStock} from 'src/app/data/actions/subscription-out-of-stock.action';
import { countryConfig } from 'src/country-config/country-config';
import {DeliveryTypeTime} from 'src/app/data/networking/models/delivery-type-time/delivery-type-time.model';
import { BrowserDetectorService } from '../../../../data/networking/services/shared/broswer-detector/browser-detector.service';
import { ProductCardVm } from '../../../../view-model/product-card/product-card.vm';
import { algoliaInit, userTokenAlgolia } from '../../../algolia/algoliaInit';
import { DeleteProductFromCartEvent } from '../../event-listeners/delete-product-from-cart/delete-product-from-cart.event';
import { SessionEvent } from '../../event-listeners/session/session.event';
import { SubstitutesEvent } from '../../event-listeners/substitutes/substitutes.event';
import { UpdateBuyAndGetModalEvent } from '../../event-listeners/update-buy-and-get-modal/update-buy-and-get-modal.event';
import { UpdateProductQuantityEvent } from '../../event-listeners/update-product-quantity/update-product-quantity.event';
import { UpdateSessionModalEvent } from '../../event-listeners/update-session-modal/update-session-modal.event';
import { AdvertisedProductsEvent } from '../../event-listeners/advertised-products/advertised-products.event';
import { PrimeConfig, PrimeSubscription } from 'src/app/data/networking/models/prime/prime';
import { ProductInterface } from 'src/app/data/networking/models/shared/responses/product-response';
import { Customer } from 'src/app/data/networking/models/customer/customer';
import { ProductDataQuantity } from 'src/app/data/networking/models/product/responses/products';
import { EventClick, EventProduct } from 'src/app/data/networking/models/event/event';
import { ConfigModule } from 'src/app/data/networking/models/config/responses/configuration-module';
import { SubscriptionInterface } from 'src/app/data/networking/models/subscriptions/subscriptions';
import { DeliveryTypeEnum } from 'src/app/data/networking/models/location/enum/delivery-type.enum';
import {VtoPlayerComponent} from '../vto-player/vto-player.component';
import {PlatformDetectionService} from 'src/app/ui/shared/services/detected-platform/platform-detection.service';

@Component({
  selector: 'app-new-product-card',
  templateUrl: './new-product-card.component.html',
  styleUrls: ['./new-product-card.component.scss'],
})
export class NewProductCardComponent implements OnInit, OnDestroy {
  @ViewChild('contentFilter', {read: ViewContainerRef}) contentFilterRef: ViewContainerRef;
  @ViewChild(VtoPlayerComponent) vtoPlayer: VtoPlayerComponent;

  @Input() idPrefix = '';
  @Input() preprocessor = 'product';
  @Input() product: ProductInterface;
  @Input() isMini = false;
  @Input() isHome = false;
  @Input() isVTO = false;
  @Input() isLorealDesign = false;
  @Input() isFlashOffer = false;
  @Input() subscribeAndSave = false;
  @Input() lazyLoaded = false;
  @Input() dataLoaded = false;
  @Input() isAlgolia = false;
  @Input() isSustitutes = false;
  @Input() queryID = '';
  @Input() positions = '';
  @Input() hasBolivarDigital = false;
  @Input() componentType:string;
  @Input() ifAdvertisedModal = false;
  @Input() isOffer = false;
  @Input() isFavorite = false;
  @Input() isCarousel = false;
  @Input() isLast = false;
  @Input() discountsLoaded = true;
  @Input() groupType = '';
  @Input() columnHalf = false;
  @Input() isFirst = false;

  countryConfig: typeof countryConfig = countryConfig;
  alive = true;
  bolivarDigital:boolean = this.countryConfig.bolivarDigital;
  browser = this.browserDetectorService.checkBrowser();
  buyAndGetModalStatus = { open: false };
  configModule: ConfigModule;
  dataBuyAndGet: Object;
  day: number;
  deliveryType= 'EXPRESS';
  gtmList = 'Carrito de compras';
  imgDelivery = '/assets/svg/icon-moto-blue.svg';
  ipAddress: string;
  isBrowser: boolean;
  isLogin: boolean;
  isResponsive = false;
  loading = false;
  modifaceEnableWeb: boolean;
  primeConfigSubs: Subscription;
  primeData: PrimeSubscription;
  primeStyles: PrimeConfig;
  productsSubscription = false;
  public customer: Customer;
  public isGroup = false;
  sasEnabled: boolean;
  showCard = true;
  start = true;
  subs:Subscription[] = [];
  subscriptions:SubscriptionInterface = {};
  txtOnSubscription = 'Te avisaremos cuando esté disponible';
  txtSubscription = 'Avísame cuando esté disponible';
  updatedItem = null;
  url = '';
  urlGo = '';
  hasColor=false;
  maxScroll= 42;
  storeDefault= '26';
  hasVariant = false;
  topsortTag = false;
  redirectToDetail=false;
  deliveryTimes: DeliveryTypeTime[] = [];
  topsortResolvedBidId:string;


  constructor(
    private vm: ProductCardVm,
    private updateQuantityEvent: UpdateProductQuantityEvent,
    private deleteProductEvent: DeleteProductFromCartEvent,
    private router: Router,
    private browserDetectorService: BrowserDetectorService,
    private sessionModalStatusEvent: UpdateSessionModalEvent,
    private updateBuyAndGetEvent: UpdateBuyAndGetModalEvent,
    private substitutesEvent: SubstitutesEvent,
    private location: Location,
    private store: Store<AppState>,
    private loginEvent: SessionEvent,
    private advertisedProd: AdvertisedProductsEvent,
    private platformDetectionService: PlatformDetectionService,
    @Inject(PLATFORM_ID) private platformId: any) {

    this.checkIfResponsive(this.platformId);
    this.checkAuthenticationStatus();
    this.configModule = vm.getConfigurationModules();
  }

  ngOnInit() {
    if (this.product.onlyOnline && !this.product?.deliveryTime) {
      this.product.deliveryTime = '4 a 5 días';
    }
    if (!this.product.onlyOnline && !this.product?.deliveryTime) {
      this.product.deliveryTime = '35 min';
    }
    this.product
      ? this.productsSubscriptionOutOfStock(this.product?.id.toString())
      : this.productsSubscriptionOutOfStock('0');

    this.getPrimeData();
    this.getModifaceConfig();

    if (this.product?.outofstore || this.product?.without_stock) {
      this.product.totalStock = 0;
    }

    this.handleRedirect();

    this.setDeliveryType();
    this.imgShowDelivery();
    if (this.isAlgolia && this.isResponsive) {
      this.showCard = false;
    }
    this.onDeleteProduct();
    this.sasEnabled = this.vm.isSasEnabled();
    this.onQuantityUpdate();
    setTimeout(() => {
      this.dataLoaded = true;
    }, 4000);
    this.hasVariant = this.product?.variants != null && this.product?.variants.length > 0;
    this.hasColor = this.product?.colors != null && this.product?.colors.length > 0;
    this.setVariantsColors();

    this.topsortTag = !!this.product?.resolvedBidId;
    this.getDeliveryTypeTime();
    if(this.product?.resolvedBidId){
      this.topsortResolvedBidId = this.product?.resolvedBidId;
    }
    
  }

  handleRedirect() {
    if (this.product?.type === 'GROUP') {
      this.urlGo = this.product?.url;
    } else {
      this.urlGo = (this.product?.url)
        ? (`/producto/${this.product?.url}`)
        : (`/producto/${this.product?.id}-${this.product?.seoUrl}`);
    }
  }

  setVariantsColors() {
    if (this.hasVariant) {
      const productId = this.product.id.toString();
      this.hasColor=true;
      const filteredByColor = this.product?.variants.filter(item => {
        const variants=item.variantDetails.some(variant => variant.groupName !== "Color");
        if(variants){
          this.redirectToDetail=true;
        }
        return item.variantDetails.some(variant => variant.groupName === "Color");
      });
      const colors = filteredByColor.reduce((accumulator, item) => {
        const color = item.variantDetails.find(variant => variant.groupName === "Color");
        const productVariation = item.item === productId;
        if (!accumulator[color.name] || productVariation) {
          color.id=item.item;
          color.hex=color.value;
          accumulator[color.name] = color;
        }
        return accumulator;
      }, {});
      let colorsFiltered=[];
      for(const color in colors) {
        colorsFiltered.push(colors[color]);
      }
      this.product.colors = colorsFiltered;
      this.hasColor = true;
    }
    if (this.hasColor) {
      this.hasColor=true;
      this.product.colors = this.product?.colors.sort((colorA, colorB) => (colorA.order > colorB.order) ? 1 : -1);
      if (this.product?.variants != null){
        this.product.color = this.product.colors.find((variation)=>{return variation.id==this.product.id.toString()});
      }
    }
  }
  ngOnDestroy() {
    this.alive = false;
    this.subs.forEach(sub => sub.unsubscribe());
  }

  checkIfResponsive(platformId){
    const mobileWidth = 786;
    this.isBrowser = isPlatformBrowser(platformId) && (navigator.userAgent.indexOf('Chrome-Lighthouse') <= -1);
    this.lazyLoaded = this.isBrowser && this.lazyLoaded;
    this.isResponsive = this.isBrowser && window.screen.width <= mobileWidth;
  }

  checkAuthenticationStatus() {
    this.loginEvent.hasCustomer.subscribe(customer => {
      this.isLogin = !customer?.isAnonymous || false;
    })
  }

  getAgile() {
    this.subscriptions.getAgile = this.vm.getAgile().subscribe();
  }

  goToGroup() {
    let isGroup = this.product?.type === 'GROUP';
    if ((this.product.deepLinkRedirectUrl && isGroup) && this.isBrowser) {
      window.open(this.product.deepLinkRedirectUrl, '_self');
      return;
    }

    if (this.product?.url && !this.product.deepLinkRedirectUrl) {
      this.router.navigate([this.product?.url]);
    }
  }

  goToDetail(event:EventClick, product:ProductInterface) {
    let isArrow: boolean;
    let isButton: boolean;
    const target = event.target;
    if (product.handleQuantity || product.listUrlImages) {
      isArrow = target.className.indexOf('arrow') !== -1;
    }
    isButton = target.nodeName.toLowerCase() === 'button'
      || target.parentNode.nodeName.toLowerCase() === 'button'
      || target.parentNode.nodeName.toLowerCase() === 'span'
      || target.closest('app-quantity-controls');
    const isDetail=(!isArrow && !isButton)
      || (product.handleQuantity && isButton)
      || !countryConfig.isColombia;
    if (isDetail) {
      const list = this.product.rsList ? this.product.rsList : '';
      this.vm.callGtmService(product, list);
      this.vm.setGtmList(product.rsList);
      const url = product.itemUrl ? product.itemUrl : `${product?.id}-${product?.seoUrl}`;
      this.router.navigate(['/producto/', url]);
    }
  }

  setDeliveryType() {
    if (this.isBrowser) {
      this.deliveryType = this.vm.getDeliveryType() || DeliveryTypeEnum.EXPRESS;
    }
  }

  stopEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  updateQuantity(data:ProductDataQuantity) {
    if (!this.loading) { return; }
    const list = data.product?.rsList ? data.product?.rsList : '';
    data = {
      ...data, list,
      preprocessor: this.preprocessor,
    };
    this.vm.updateQuantity(data)
      .pipe(
        finalize(() => { this.loading = false; }),
      )
      .subscribe(response => {
        if (response.offerComboPopUp && response.quantitySold === 1) {
          this.dataBuyAndGet = response.offerComboPopUp;
          this.buyAndGetModalStatus = { open: true };
          const dataBAG = {
            data: this.dataBuyAndGet,
            status: this.buyAndGetModalStatus,
          };
          this.updateBuyAndGetEvent.updateProductBuyAndGet(dataBAG);
        }
        this.product = {...this.product, totalStock: this.product?.totalStock};
        if (response?.totalStock) {
          this.product.totalStock = response?.totalStock
        }
      },()=>{
        this.product.totalStock = 0;
      });
  }

  updateSubscribeAndSaveQuantity(data:ProductDataQuantity) {
    if (!this.loading) { return; }
    this.vm.updateSasQuantity(data)
      .pipe(
        finalize(() => { this.loading = false; }),
        takeWhile(() => this.alive),
      )
      .subscribe();
  }

  goToDetailVTO(product:ProductInterface) {
    const url = `${product?.id}-${product?.seoUrl}`;
    this.router.navigate(['/producto/', url]);
  }

  getModifaceConfig(): void {
    this.store.select('modifaceConfig').subscribe(({ data }) => {
      this.modifaceEnableWeb = data?.enableWeb;
    });
  }

  goToVTO(product: ProductInterface) {
    if (this.modifaceEnableWeb && this.vtoPlayer) {
      this.vtoPlayer.start(product);
    }
  }

  onQuantityUpdate() {
    this.updateQuantityEvent.updateProductQuantity
      .pipe(
        takeWhile(() => this.alive),
      )
      .subscribe((data: ProductDataQuantity) => {
        const empty = data.quantity === 0;
        const productIdCheck = data.product?.id === this.product?.id;
        const pathValid = this.location.path() !== '/carrito';
        const stockCheck = (data.quantity || empty);
        const checkProductQuantity=data && productIdCheck && stockCheck && pathValid;
        if (checkProductQuantity) {
          this.updatedItem = data.product?.id;
          const product:ProductDataQuantity = { product: { ...this.product }, quantity: data.quantity };
          this.loading = true;

          if (this.subscribeAndSave) {
            this.updateSubscribeAndSaveQuantity(product);
          } else {
            this.updateQuantity(product);
          }
        }
      });
  }

  onDeleteProduct() {
    this.subscriptions.deleteProductEvent = this.deleteProductEvent.productToDelete
      .pipe(debounceTime(100)).subscribe((event: EventProduct) => {
        const currentProductId =event.product?.id === this.product?.id;
        const pathValid = this.location.path() !== '/carrito';
        const checkProduct =event && currentProductId && pathValid;
        if (checkProduct) {
          let observable;
          if (event.subscribeAndSave) {
            observable = this.vm.removeSasProduct({
              product: event.product,
              list: this.gtmList,
              preprocessor: this.preprocessor,
            });
          } else {
            observable = this.vm.removeProduct({
              product: event.product,
              list: this.gtmList,
              preprocessor: this.preprocessor,
            });
          }
          this.deleteProduct(observable);
        }
      });
  }

  deleteProduct(observable:Observable<ProductInterface>) {
    observable
      .pipe(
        debounceTime(100),
        first(),
        finalize(() => {
          this.updatedItem = this.updatedItem === 0 ? undefined : 0;
          this.getAgile();
        }),
      )
      .subscribe();
  }

  prevFilter() {
    this.contentFilterRef.element.nativeElement.scrollLeft -= this.maxScroll;
  }

  nextFilter() {
    this.contentFilterRef.element.nativeElement.scrollLeft += this.maxScroll;
  }

  algoliaEvent() {
    this.advertisedProd.closeAdvertisedModal(true);

    const user = this.vm.getCustomer()?.analyticsUUID || userTokenAlgolia;
    const id = this.product?.id;
    const positions = typeof this.positions === 'number' ? this.positions : parseInt(this.positions, 10);
    const platform = this.platformDetectionService.detectPlatform();

    if (this.queryID) {
      algoliaInit('clickedObjectIDsAfterSearch', {
        userToken: userTokenAlgolia,
        authenticatedUserToken: user,
        eventName: 'Product Viewed After Search',
        index: countryConfig.algolia.index,
        objectIDs: [`${id}`],
        queryID: this.queryID,
        positions: [this.positions + 1],
        analyticsTags: [platform],
      });

      this.updateQuantityEvent.sendQueryID({queryID: this.queryID});
    } else {
      algoliaInit('clickedObjectIDs', {
        userToken: userTokenAlgolia,
        authenticatedUserToken: user,
        eventName: 'Product Viewed',
        index: countryConfig.algolia.index,
        objectIDs: [`${id}`],
        ...(this.queryID ? {queryID: this.queryID, positions: [positions + 1]} : {}),
        analyticsTags: [platform],
      });
    }
  }

  imgShowDelivery() {
    if (this.deliveryType === 'NATIONAL') {
      this.imgDelivery = '/assets/svg/camino-icono.svg';
    } else if (this.deliveryType === 'ENVIALOYA') {
      this.imgDelivery = '/assets/svg/envio_venezuela_azul.svg';
    }
  }

  selectProductSus() {
    this.substitutesEvent.getItemSustitutes(this.product);
  }

  goDetail(product:ProductInterface) {
    this.router.navigate([`/producto/${product?.id}-${product?.seoUrl}`]);
  }

  getPrimeData() {
    this.primeConfigSubs = this.store.select('prime')
      .subscribe(({ config }) => {
        if (!config?.length) return;
        this.primeStyles = config[0];
        this.vm.getPrimeSubscription().subscribe(
          res => {
            this.primeData = res;
            this.validateSubscription((res.expirationDate) ? res.expirationDate : '');
          })
      });

    this.subs.push(this.primeConfigSubs);
  }

  validateSubscription(expirationDate?: number) {
    if (expirationDate) {
      const today = new Date().getTime();
      this.primeData.active = Boolean(expirationDate >= today) ;
    }
    if (!this.primeStyles?.feature_active_web && !this.primeData.active) {
      this.product.primeDescription = null;
      this.product.primePrice = null;
      this.product.primeTextDiscount = null;
    }
  }

  saveNonStockItem(id:number) {
    const shopping = this.vm.getCity();
    const valueId = id.toString();
    const idConcat = `${valueId}-${shopping?.defaultStore}`;

    if (this.isLogin) {
      const user = this.vm.getCustomer()?.email;
      const subscription = this.store.select('saveSubscriptionOutOfStock').subscribe(({ items }) => {
        const productExisting = items.filter(item => item.split('-')[0] === valueId)
        if (productExisting.length > 0) {
          this.productsSubscription = true;
        } else {
          this.vm.gtmSuscribe(idConcat);
          this.vm.saveNonStockItem(user, valueId).subscribe(() => {
            this.store.dispatch(saveSubscriptionOutOfStock({item: idConcat}));
            this.store.dispatch(modalSubscriptionOutOfStockBraze({show: true}));
            this.productsSubscription = true;
            setTimeout(() => {
              this.store.dispatch(modalSubscriptionOutOfStockBraze({show: false}));
            }, 8000);
          });

          this.getSaveNonStockItem(valueId);
        }
      });
      subscription.unsubscribe();
    } else {
      this.sessionModalStatusEvent.changeModalStatus({ open: true });
    }
  }

  removeNonStockItem(id: number) {
    const shopping = this.vm.getCity();
    const valueId = id.toString();
    const idConcat = `${valueId}-${shopping?.defaultStore}`;

    if (this.isLogin) {
      const user = this.vm.getCustomer()?.email;

      this.vm.removeNonStockItem(user, valueId).subscribe(res => {
        if (res.code === 'OK') {
          this.productsSubscription = false;
          this.store.dispatch(removeSubscriptionOutOfStock({item: idConcat}));
          this.getSaveNonStockItem(valueId);
        }
      });
    } else {
      this.sessionModalStatusEvent.changeModalStatus({open: true});
    }
  }

  getSaveNonStockItem(id: string) {
    let items = this.vm.getItemLocalStorage('nonStockItems');

    if (!items) {
      items = [];
    }

    const numericId = Number(id);

    if (items.includes(numericId)) {
      items = items.filter(item => item !== numericId);
    } else {
      items.push(numericId);
    }

    this.vm.setItemLocalStorage('nonStockItems', items);
  }

  productsSubscriptionOutOfStock(id: string) {
    let isProductSubscribed = false;

    const storeSubscription = this.store.select('saveSubscriptionOutOfStock').subscribe(({items}) => {
      const productExisting = items.filter(item => item.split('-')[0] === id);
      if (productExisting.length > 0) {
        isProductSubscribed = true;
      }
    });

    const localStorageSubscription = this.vm.getItemLocalStorage('nonStockItems');
    if (localStorageSubscription) {
      const productExisting = localStorageSubscription.filter(item => item === Number(id));
      if (productExisting.length > 0) {
        isProductSubscribed = true;
      }
    }

    this.productsSubscription = isProductSubscribed;

    storeSubscription.unsubscribe();
  }

  searchWord(product:ProductInterface) {
    let filter = '';

    if (product?.rms_class) {
      filter = `AND rms_class:"${product?.rms_class}"`;
    } else if (product?.SubCategoría) {
      filter = `AND SubCategoría:"${product?.SubCategoría}"`;
    } else if (product?.subCategory) {
      filter = `AND subCategory:"${product?.subCategory}"`;
    }

    const query = this.isHome ? ' ' : '';
    this.router.navigate(['buscar'], {
      queryParams: {
        product: query,
        filtros: filter
      },
      queryParamsHandling: 'merge',
    });
  }

  get imgDeliveryType():string {
    if (this.product.onlyOnline) {
      return 'assets/svg/icono-envio-marketplace.svg';
    }

    const deliveryTypeImages = {
      'EXPRESS': 'assets/svg/moto.svg',
      'NATIONAL': 'assets/svg/icono_envio_nacional.svg',
      'ENVIALOYA': 'assets/svg/envio_venezuela.svg'
    };
    return (deliveryTypeImages[this.deliveryType]) || '';
  }

  get showPrice():boolean {
    const petalType = 3;
    return countryConfig.productCard.showPrice ||
      (countryConfig.productCard.showPrice&& this.product.petalType !== petalType);
  }
  shouldDisplayPrimePrice(): boolean {
    const primePrice = this.product.primePrice && this.product.primePrice > 0;
    const primeActive = this.primeData?.active  && primePrice;
    return this.product.totalStock && primeActive && primePrice;
  }

  shouldDisplayPrimePetal(): boolean {
    const primePrice = this.product.primePrice && this.product.primePrice > 0;
    const regularPrice = this.product.offerPrice || this.product.fullPrice;
    const primeActive = this.primeData?.active;

    return primePrice && regularPrice > this.product.primePrice && !primeActive;
  }

  shouldDisplayPrimePetalTag(): boolean {
    const featureActive = this.primeStyles?.feature_active_web;
    const hasStock = this.product.totalStock > 0;

    return featureActive && !this.primeData?.active && hasStock;
  }

  isCardVisible(): boolean {
    return !this.isFlashOffer && this.showCard && !this.countryConfig.getService;
  }
  requiresPrescription(): boolean {
    return (String(this.product.requirePrescription).toLowerCase() === 'true');
  }

  getPrimeBorder():boolean{
    const brazeCarousel = this.componentType == 'BRAZE_CAROUSEL';
    const primeActive = this.primeData?.active;
    return this.product.primeTextDiscount && brazeCarousel && primeActive;
  }
  showQuantityControl():boolean{
    const itemOptics = this.product?.itemOpticsComplete;
    const stockAvailable = this.product?.totalStock;
    return !this.isSustitutes && stockAvailable && !this.redirectToDetail && !itemOptics;
  }

  showPriceText(): number {
    return (this.product.offerPrice && this.product.offerPrice > 0) ? this.product.offerPrice : this.product.fullPrice;
  }

  showPriceTag(): boolean {
    const hasPrime = this.product.primePrice > 0 && this.primeData?.active;
    const stockAvailable = this.product?.totalStock;

    const offerPrice = this.product.offerPrice && this.product.offerPrice > 0 ? this.product.offerPrice : this.product.fullPrice;
    const {primePrice} = this.product;

    const isPrimeBetter = hasPrime && primePrice < offerPrice;

    return stockAvailable && (!hasPrime || !isPrimeBetter);
  }

  showPrimePriceTag(): boolean {
    const hasPrime = this.product.primePrice > 0 && this.primeData?.active;
    const stockAvailable = this.product?.totalStock;

    const offerPrice = this.product.offerPrice && this.product.offerPrice > 0 ? this.product.offerPrice : this.product.fullPrice;
    const {primePrice} = this.product;

    const isPrimeBetter = hasPrime && primePrice < offerPrice;

    return stockAvailable && isPrimeBetter;
  }

  getPrimePriceColor(): string {
    return this.primeData?.active ? this.primeStyles?.primary_dark_color : '#418fde';
  }

  showPrimePriceText(): boolean {
    const stockAvailable = this.product?.totalStock;
    const offerPrice = this.product.offerPrice && this.product.offerPrice > 0;
    const offerPrime = this.product.primePrice && this.product.primePrice > 0 && this.primeData?.active;

    return stockAvailable && (offerPrice || offerPrime);
  }

  getDeliveryText(): string {
    const deliveryTypeMarketplaceLowerCase = DeliveryTypeEnum.MARKETPLACE?.toLowerCase();
    const deliveryTypeProductLowerCase = this.deliveryType?.toLowerCase();
    const deliveryTypeLowerCase = this.product?.onlyOnline
      ? deliveryTypeMarketplaceLowerCase
      : deliveryTypeProductLowerCase;
    const deliveryTypeTime = this.deliveryTimes
      .find(item => item?.type?.toLowerCase() === deliveryTypeLowerCase);

    return deliveryTypeTime?.estimatedTime;
  }

  showColorPicker(): boolean{
    return this.product && this.product.color && this.product.colors && !!this.product.totalStock;
  }
  showSizeTag(): boolean{
    return this.product && this.product.filtersLoreal && !this.product.colors;
  }
  showVtoTag(isVto: boolean):boolean{
    const stock = this.product.totalStock;
    return stock && this.modifaceEnableWeb && isVto && this.product.filterCategories && !this.ifAdvertisedModal;
  }
  showPrimeTextDiscount():boolean{
    return this.product.primePrice && !this.primeData?.active;
  }
  colorPickerLimit():boolean{
    const colorLimit = this.product.colors.length > 5;
    const colorPickerDisable = (this.modifaceEnableWeb && !this.isVTO && this.product.filterCategories && !this.ifAdvertisedModal);
    const isVertical = !this.isAlgolia && this.product.colors.length > 2 && this.modifaceEnableWeb;
    return colorLimit && !colorPickerDisable || isVertical;
  }

  showBzRating():boolean{
    return this.product.totalStock && !this.isHome && !this.isGroup && !this.isVTO;
  }
  showFullPrice():boolean{
    const offerPrice = this.product.offerPrice && this.product.offerPrice > 0;
    return this.product?.totalStock && offerPrice;
  }

  showCardUnique(): boolean {
    if (!this.product.type) {
      if (this.groupType !== 'suggests') {
        return true;
      }

      return this.groupType === 'suggests' && !this.isResponsive;
    }

    return false;
  }

  getDeliveryTypeTime(): void {
    const subscription = this.vm.getDeliveryTypeTime()
      .subscribe(response => {
        if (response?.deliveryTimes) {
          this.deliveryTimes = response?.deliveryTimes;
        }
      });
    this.subs.push(subscription);
  }
}
